export default __webpack_public_path__ + "static/media/Kerststukjes maken.dd3058da.jpg";